import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDialog } from "../../context/redux/reducers/dialog";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";

const BIModal = () => {
  const dispatch = useDispatch();

  const modalOpen = useSelector((state) => state.dialog.open);
  const maxWidth = useSelector((state) => state.dialog.maxWidth);
  const title = useSelector((state) => state.dialog.title);
  const scroll = useSelector((state) => state.dialog.scroll);
  const data = useSelector((state) => state.dialog.data);

  const handleclose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(setDialog(false, maxWidth, title, data, scroll));
  };

  return (
    <Dialog
      open={modalOpen}
      keepMounted
      scroll={scroll}
      onClose={handleclose}
      maxWidth={maxWidth}
      fullWidth
      sx={{ textAlign: "center" }}
    >
      <DialogTitle color="primary" fontWeight="bold" lineHeight="1.5rem">
        {title}
      </DialogTitle>
      <DialogContent>{data}</DialogContent>
    </Dialog>
  );
};

export default BIModal;
